// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
import type { ServicePackageReduxAction, ServicePackageState } from "./servicePackageTypes"
import {
  FETCH_SERVICE_PACKAGE_RULES_FAILURE,
  FETCH_SERVICE_PACKAGE_RULES_REQUEST,
  FETCH_SERVICE_PACKAGE_RULES_SUCCESS,
} from "../consts"

export const initialState: ServicePackageState = {
  apiStatus: "loading",
  level: null,
  rules: null,
  isLegacy: null,
  savingPrice: null,
  handlingFeePrice: null,
}

export default function servicePackageReducer(
  state: ServicePackageState | null | undefined = initialState,
  action: ServicePackageReduxAction,
) {
  switch (action.type) {
    case FETCH_SERVICE_PACKAGE_RULES_REQUEST:
      return initialState
    case FETCH_SERVICE_PACKAGE_RULES_SUCCESS:
      return {
        ...state,
        apiStatus: "success",
        level: action.res.level,
        rules: action.res.rules,
        isLegacy: action.res.isLegacy,
        savingPrice: action.res.savingPrice,
        handlingFeePrice: action.res.handlingFeePrice,
      }
    case FETCH_SERVICE_PACKAGE_RULES_FAILURE:
      return {
        ...state,
        apiStatus: "error",
        level: null,
        rules: null,
        isLegacy: null,
        savingPrice: null,
        handlingFeePrice: null,
      }
    default:
      return state
  }
}
